import React, { memo, SVGProps } from 'react'

export const StatusExpired = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM11.2 6.60267C11.2 6.16533 11.5627 5.80267 12 5.80267C12.4373 5.80267 12.8 6.16533 12.8 6.60267V13.7813C12.8 14.2187 12.4373 14.5813 12 14.5813C11.5627 14.5813 11.2 14.2187 11.2 13.7813V6.60267ZM12.5653 17.9627C12.416 18.112 12.2133 18.1973 12 18.1973C11.7867 18.1973 11.584 18.112 11.4347 17.9627C11.2853 17.824 11.2 17.6107 11.2 17.408C11.2 17.1947 11.2853 16.9813 11.4347 16.832C11.5093 16.7573 11.5947 16.704 11.6907 16.6613C11.9893 16.544 12.3413 16.608 12.5653 16.832C12.7147 16.9813 12.8 17.1947 12.8 17.408C12.8 17.6213 12.7147 17.824 12.5653 17.9627Z"
      fill="currentColor"
    />
  </svg>
))
